<template>
  <div
    id="app"
    :style="{
      '--theme': $store.state.theme.theme,
      '--border': $store.state.theme.border,
      '--background': $store.state.theme.background,
    }"
  >
    <!-- <keep-alive
      v-if="include && include.length > 0"
      :include="include.join(',')"
    >
      <router-view />
    </keep-alive>
    <router-view v-else /> -->

    <!-- 可以被缓存的视图组件 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不可以被缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <Footer />
    <ElementTheme v-show="false" />
  </div>
</template>

<script>
import { getToken, setToken } from "@/utils/auth";
import Cookies from "js-cookie";
import { getUserInfo } from "@/api/user";
export default {
  name: "App",
  data() {
    return {
      include: [],
    };
  },
  created() {},
  mounted() {},
  components: {
    ElementTheme: () => import("@/views/system/elementTheme.vue"),
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      getUserInfo()
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            let userInfo = res.data;
            this.$store.dispatch("user/amendInfo", userInfo);
            this.$store.dispatch("user/userInfo", {
              user: res.data,
              token: getToken(),
            });
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
          }
        })
        .catch((err) => {});
    },
  },

  watch: {
    $route(to, form) {
      this.token = getToken();
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (this.token && this.token != "") {
        if (!(userInfo && userInfo.id * 1 > 0)) {
          // 获取用户信息
          this.getUserInfo();
        }
      }
    },
  },
};
</script>
<style lang="scss">
.container {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  position: relative;
}
</style>
